/* eslint-disable */
import * as React from "react";

import { useParameter } from "../../../shared";
import { ReportToolbarGroup } from "../../../components/ReportToolbar";
import { CommoditiesControl } from "../controls/CommoditiesControl";
import { UnitsControl } from "../controls/UnitsControl";
import { FrequencyControl } from "../controls/FrequencyControl";
import { useFavourite } from "./useFavourite";

export default function () {
  const [commodity] = useParameter<number>("@commodities");

  useFavourite();
  return (
    <ReportToolbarGroup vertical>
      <CommoditiesControl />
      <UnitsControl key={commodity || undefined} />
      <FrequencyControl />
    </ReportToolbarGroup>
  );
}
